<template>
  <div id="app">
    <NavigationBar />
    <b-container style="max-width: 1360px"  v-if="$store.state.isLoaded">
      <router-view></router-view>
    </b-container>
    <b-container v-if="!$store.state.isLoaded">
      <center>
        <h2>Ładowanie aplikacji...</h2>
      </center>
    </b-container>
  </div>
</template>

<script>
import NavigationBar from './layout/navigationBar.vue'

export default {
  name: 'App',
  components: { NavigationBar },
  beforeCreate() {
    //TODO Spróbować znaleźć lepsze rozwiązanie
    if (this.$store.getters.isLoggedIn) {
      this.$store.dispatch('loadInitialData');
    } else {
      this.$store.state.isLoaded = true;
    }
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
@import './styling/globalStyle.css';
@import './styling/iconStyle.css';
</style>
